import styled from "styled-components";

export const StyledTooltipListPart = styled.div`
    margin-bottom: 16px;
`;
